import Spinner from '@scalero-inc/forno-spinner';

import { useImagesQuery } from 'hooks/api/figma/image';

import { useReadOnly } from '../../read-only-context';

import styles from './style.module.css';

function ReadOnlyPreviewImage() {
  const { figmaId, frame, doc } = useReadOnly();
  const { data, isLoading, error } = useImagesQuery({
    file: figmaId,
    nodes: [frame],
  });
  const {
    absoluteBoundingBox: { width },
  } = doc;

  if (isLoading) return <Spinner />;
  if (error) return <pre>{error}</pre>;

  const { images } = data;
  const preview = images[frame];

  return (
    <div className={styles['image-wrapper']}>
      <img
        src={preview}
        alt={styles.preview}
        style={{
          maxWidth: `${width}px`,
        }}
      />
    </div>
  );
}

export default ReadOnlyPreviewImage;
